export default __webpack_public_path__ + "static/media/all.e0f1239c.svg";